import { render, staticRenderFns } from "./generate-order.vue?vue&type=template&id=5aaecda8&scoped=true"
import script from "./generate-order.vue?vue&type=script&lang=js"
export * from "./generate-order.vue?vue&type=script&lang=js"
import style0 from "./generate-order.vue?vue&type=style&index=0&id=5aaecda8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaecda8",
  null
  
)

export default component.exports